export const getBSWholeWheatNaanPackage = newProduct => {
  const newBSWholeWheatNaanPackage = {
    UPC: newProduct.UPC,
    Size: newProduct.Size,
  }
  return newBSWholeWheatNaanPackage
}

export const updateBSWholeWheatNaanPackage = newProduct => {
  const newBSWholeWheatNaanPackage = {
    UPC: newProduct.UPC,
    Size: newProduct.Size,
  }
  return newBSWholeWheatNaanPackage
}
